// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1-zz5","message":"styles_message__38nzj"};